import React from "react";
import { UserAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";

const ProtectedPlatformAdminRoute = ({ children }) => {
  const { user } = UserAuth();

  if (!user?.isPlatformAdmin) {
    return <Navigate to="/home" />;
  }

  return children;
};

export default ProtectedPlatformAdminRoute;
